// @ts-check
import _ from 'lodash';

/**
  * Creates a function that can be used to determine if the item send to the function is contained within the list
 * @param {Record<string, any>[]} collection Check this collection for the item
 * @param {function (Record<string, any>): any} iteratee Iteratee for item and items in collection
 * @returns {function(*): boolean}
 */
export const isItemInCollection = (collection, iteratee) => {
  return item => _.some(collection, s => _.isEqual(iteratee(s), iteratee(item)));
};

/**
 * Search specific properties of a collection
 * @template {Record<string, any>} T
 * @template {keyof T} K
 * @param {T[]} collection Collection to search in
 * @param {string} searchText Text or regexp. If text then the search will be case insensitive
 * @param {K[]} [properties] The propries to search in. Default same as object (e.g. identity).
 * @returns {T[]}
 */
export const search = (collection, searchText, ...properties) => {
  const pickProperties = (properties == null || properties?.length === 0) ? [_.identity] : _.map(properties, _.iteratee);

  const transform = _.isRegExp(searchText) ? _.identity : _.toLower;
  const searchFunc = _.isRegExp(searchText) ? 'search' : 'indexOf';
  const _searchText = transform(searchText);
  return _.filter(collection, item =>
    _.some(pickProperties, pickProperty => _.invoke(transform(pickProperty(item)), searchFunc, _searchText) !== -1)
  );
};
